module.exports = __webpack_public_path__ + "static/img/aa5.71096bd3.png";